import * as React from "react";
const SvgInactiveBoth = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-051d7ab0-dc9c-44e0-9f29-ae9a5a151723", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m2.75,5.77v12.23c0,.97.78,1.75,1.75,1.75h10c.97,0,1.75-.78,1.75-1.75V2c0-.97-.78-1.75-1.75-1.75h-6.61c-.5,0-.97.21-1.3.58l-3.39,3.77c-.29.32-.45.74-.45,1.17Z", style: {
  fill: "#e5e5e5",
  stroke: "#e5e5e5",
  strokeWidth: ".5px"
} }), /* @__PURE__ */ React.createElement("path", { d: "m19.5,4.25h-1.75v14c0,1.66-1.34,3-3,3h-7v.75c0,.97.78,1.75,1.75,1.75h10c.97,0,1.75-.78,1.75-1.75V6c0-.97-.78-1.75-1.75-1.75Z", style: {
  fill: "#e5e5e5",
  stroke: "#e5e5e5",
  strokeWidth: ".5px"
} }));
export default SvgInactiveBoth;
